import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'
// import { deviceLayout } from 'styles/breakpoint'

type ContainerProps = {
  ['data-banner-height']?: number
  ['data-content-padding']?: number
}

export const StyledContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: ${(props: ContainerProps) => props?.['data-banner-height']}px;
  margin-bottom: 32px;
  background-color: white;
  .animation-image {
    position: absolute;
    right: 0;
    left: 0;
    margin: auto;
    margin-top: auto;
    margin-right: auto;
    margin-bottom: auto;
    margin-left: auto;
    opacity: 0;
  }

  .heading {
    opacity: 0;
  }

  .description {
    margin-top: 12px;
    opacity: 0;
  }
  ${MediaQueries.mbDown} {
    padding: 16px;
    z-index: 100;
    .animation-image {
      bottom: 32px;
      width: 100%;
      height: auto;
    }
  }
  ${MediaQueries.mbUp} {
    z-index: 11;
    .animation-image {
      top: 0;
      bottom: 0;
      width: auto;
      height: ${(props: ContainerProps) => props?.['data-banner-height']}px;
    }
  }
`

export const StyledHeadingContainer = styled.div`
  position: absolute;
  max-width: 368px;

  ${MediaQueries.mbUp} {
    top: 7%;
    left: ${(props: ContainerProps) => props?.['data-content-padding']}px;
    .heading {
      opacity: 0;
    }

    .description {
      margin-top: 16px;
      opacity: 0;
    }
  }
`

export const StyledDataContainer = styled.div`
  position: absolute;
  ${MediaQueries.mbDown} {
    width: 100%;
    top: 0;
    left: 0;
  }

  ${MediaQueries.mbUp} {
    top: 41%;
    left: ${(props: ContainerProps) => props?.['data-content-padding']}px;
  }
  .country-title {
    color: #ffca49;
    font-family: 'Inter';
    font-size: 24px;
    font-weight: bold;
    line-height: 36px;
    opacity: 0;
  }

  .charts-wrapper {
    display: flex;
    ${MediaQueries.mbDown} {
      margin-bottom: 12px;
    }

    ${MediaQueries.mbUp} {
      margin-bottom: 16px;
    }
  }
`

export const StyledLegendDesktopContainer = styled.div`
  position: absolute;

  ${MediaQueries.mbUp} {
    bottom: 2%;
    left: ${(props: ContainerProps) => props?.['data-content-padding']}px;
  }
`

export const StyledMapWrapper = styled.div`
  position: relative;
  min-height: 400px;
  ${MediaQueries.mbDown} {
    margin-top: 24px;
  }
`

export const StyledPieChart = styled.div`
  text-align: center;

  .chart-container {
    position: relative;
    display: flex;
    width: 60px;
    height: 60px;
    align-items: center;
    justify-content: center;
    .data-label {
      position: absolute;
      color: ${theme.colors.primaryBase};
      font-size: 12px;
      font-weight: bold;
      line-height: 18px;
      .value-number {
        display: inline;
      }
    }
  }
  .chart-name {
    color: ${theme.colors.primaryBase};
    font-size: 14px;
    font-weight: 600;
    line-height: 22px;
  }
  ${MediaQueries.mbDown} {
    width: 270px;
    height: 270px;
    margin: auto;
    margin-top: -32px;
    .chart-container {
      margin-bottom: 4px;
    }
  }

  ${MediaQueries.mbUp} {
    width: 310px;
    height: 310px;
    margin-left: 16px;
    margin-top: -16px;
    .chart-container {
      margin-bottom: 8px;
    }
  }
`
export const StyledLegendContainer = styled.div`
  min-height: 20px;
  color: ${theme.colors.gray500};
  font-size: 12px;
  font-weight: normal;
  line-height: 18px;
  .legend {
    display: flex;
    align-items: center;
    .legend-label {
      text-align: start;
    }
  }

  ${MediaQueries.mbDown} {
    position: absolute;
    bottom: 36px;
    .legend {
      margin-bottom: 4px;
    }
  }
  ${MediaQueries.mbUp} {
    display: flex;
    margin-top: 12px;
    .legend {
      margin-right: 32px;
    }
  }
`

export const StyledLegendBox = styled.div`
  width: 20px;
  height: 20px;
  margin-right: 6px;
  border-radius: ${theme.borderRadius};
`

export const StyledPreviousMap = styled.div`
  position: absolute;
  top: 50%;
  left: 3%;
  flex-direction: column;
  transform: translateY(-50%);
  img {
    width: 40px;
    height: 40px;
    cursor: pointer;
  }
`

export const StyledNextMap = styled.div`
  position: absolute;
  top: 50%;
  right: 3%;
  flex-direction: column;
  transform: translateY(-50%);
  img {
    width: 40px;
    height: 40px;
    cursor: pointer;
  }
`

export const StyledDotsContainer = styled.div`
  position: absolute;
  ${MediaQueries.mbDown} {
    bottom: 16px;
  }
  ${MediaQueries.mbUp} {
    bottom: 24px;
  }
  left: 50%;
  display: flex;
  transform: translateX(-50%);
`
export const StyledDot = styled.div`
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  background-color: ${theme.colors.neutral200};
  border-radius: 50%;
  cursor: pointer;
  &[data-active='true'] {
    background-color: ${theme.colors.primaryBase};
  }
`
export const StyledPaging = styled.div`
  position: absolute;
  right: ${(props: ContainerProps) => props?.['data-content-padding']}px;
  bottom: 2%;
  color: ${theme.colors.gray500};
  font-size: 22px;
  font-weight: 600;
  line-height: 32px;
`
